import { Alert, Box, Button, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "@/features/auth/authContext";
import { hasAnyPlatformRole, roleLabels, type PlatformRole } from "@/features/auth/roles";

type RoleProtectedRouteProps = {
  allowedRoles: readonly PlatformRole[];
  children: React.ReactNode;
};

export function RoleProtectedRoute({ allowedRoles, children }: RoleProtectedRouteProps) {
  const { profile } = useAuth();
  const allowed = hasAnyPlatformRole(profile, allowedRoles);

  if (allowed) {
    return children;
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 880 }}>
      <Paper variant="outlined" sx={{ p: { xs: 2.5, sm: 3 } }}>
        <Stack spacing={2}>
          <Stack spacing={0.75}>
            <Typography variant="h1">Acesso restrito</Typography>
            <Typography color="text.secondary">
              Esta área faz parte da administração do GeoAnalytics e depende de permissões
              específicas.
            </Typography>
          </Stack>
          <Alert severity="warning">
            Perfis autorizados: {allowedRoles.map((role) => roleLabels[role]).join(", ")}.
          </Alert>
          <Button
            component={RouterLink}
            to="/painel"
            variant="contained"
            sx={{ alignSelf: "flex-start" }}
          >
            Voltar ao painel
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
